<template>
    <v-container fluid fill-height>
        <v-layout :align-center="true" :justify-center="true">
            <v-flex xs12 sm8 md4>
                <v-card>
                    <v-card-title>Вы не авторизованы</v-card-title>
                    <v-card-subtitle>Пожалуйста, войдите в систему</v-card-subtitle>
                    <v-card-text>
                        <v-form>
                            <v-text-field label="Логин" v-model="model.username" prepend-icon="mdi-account"
                                          :error-messages="errors.username"
                                          @keyup.enter="submit"
                            />
                            <v-text-field label="Пароль" v-model="model.password"
                                          prepend-icon="mdi-lock" id="password" type="password"
                                          :error-messages="errors.password"
                                          @keyup.enter="submit"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions style="padding: 16px">
                        <v-btn text @click="submit">Войти</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject} from 'vue-property-decorator'
import Api from '@/services/Api'
import {BackendException, ValidationErrors} from '@/utils/HttpClient'
import {SingleErrors} from '@/utils/Errors'

@Component
export default class LogInView extends Vue
{
    @Inject('api') private api!: Api

    model = {
        username: '',
        password: '',
    }

    errors: SingleErrors = {
        username: '',
        password: '',
    }

    setValidationErrors(e: ValidationErrors) {
        for (const k in e) {
            this.errors[k] = e[k][0]
        }
    }

    async submit() {
        try {
            const {user} = await this.api.logIn(this.model)
            this.$store.commit('setUser', user)
            await this.$router.push('/')
        } catch (e) {
            if (e instanceof ValidationErrors) {
                this.setValidationErrors(e)
            } else if (e instanceof BackendException) {
                this.errors[''] = e.message
            }
        }
    }
}
</script>
